import { SxProps, Theme } from '@mui/system';
import { useNotification } from '@revenuewell/front-end-bundle';
import { FC, useState } from 'react';
import { usePatientProfile } from '../../../../../../../../hooks/use-patient-profile';
import { ContactApi } from '../../../../../../../../services/api-client/contact-api';
import {
  TreatmentPlanItemModel,
  TreatmentPlanModel
} from '../../../../../../../../services/api-client/contact-api.types';
import { StyledDataGrid } from '../../../../../../../shared/grid/grid.styles';
import { NoDataComponent } from '../../../../../../../shared/grid/no-data';
import { TreatmentPlanItemsTableColumns } from './treatment-plan-items-table.columns';

export interface TreatmentPlanItemsTableProps {
  treatmentPlan: TreatmentPlanModel;
  onItemChange?: (item: TreatmentPlanItemModel) => void;
  isTreatmentPlanCampaignActive: boolean;
  sx?: SxProps<Theme> | undefined;
}

export const TreatmentPlanItemsTable: FC<TreatmentPlanItemsTableProps> = (props) => {
  const { treatmentPlan, onItemChange, isTreatmentPlanCampaignActive } = props;
  const { showError } = useNotification();
  const { contactDetails, locationId } = usePatientProfile();
  const [isLoading, setIsLoading] = useState(false);
  const contactApi = ContactApi.getInstance();

  const sx = {
    '--DataGrid-overlayHeight': '280px',
    color: 'black',
    cursor: 'default',
    '& .MuiDataGrid-virtualScroller': { overflow: 'hidden' },
    ...props.sx
  };

  const handleRowSwitch = async (item: TreatmentPlanItemModel, checked: boolean) => {
    setIsLoading(true);

    try {
      onItemChange?.({ ...item, incudeFollowUp: checked });
      await contactApi.updateTreatmentPlanItem(contactDetails.id, locationId, treatmentPlan.id, item.id, {
        incudeFollowUp: checked
      });
    } catch {
      onItemChange?.({ ...item, incudeFollowUp: !checked });
      showError('Unable to update Treatment Plan item.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <StyledDataGrid
        rows={treatmentPlan.treatmentPlanItems}
        columns={TreatmentPlanItemsTableColumns({
          isLoading,
          onSwitch: handleRowSwitch,
          isTreatmentPlanCampaignActive
        })}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 99 }
          },
          columns: {
            columnVisibilityModel: { id: false }
          }
        }}
        slots={{ noRowsOverlay: NoDataComponent }}
        disableRowSelectionOnClick
        columnHeaderHeight={36}
        rowHeight={50}
        autoHeight={true}
        disableColumnMenu={true}
        hideFooter={true}
        hideFooterSelectedRowCount={true}
        disableVirtualization
        sx={sx}
      />
    </>
  );
};
